import { useServer } from '../../../../../services/server'
import { FileTile, FileType, Modal, ModalId } from '../../../../../features/ui'
import { FiscalDocument } from "../../../../fiscal-documents"
import { useEffect, useState } from 'react'
import { fileHelpers } from '../../../../../features/files'

type Props = {
    fiscalDocument?: FiscalDocument
}

export const DownloadInvoiceModal = (props: Props) => {
    const { fiscalDocument } = props

    const { downloadFileFromUrl } = useServer()
    const { fiscalDocumentFileName } = fileHelpers
    const [fileName, setFileName] = useState<string>()
    const [pdfUrl, setPdfUrl] = useState<string>()

    useEffect(() => {
        fiscalDocument && setFileName(fiscalDocumentFileName(fiscalDocument))
        fiscalDocument && setPdfUrl(fiscalDocument.pdfUrl)
    }, [fiscalDocument])
    
    const onSubmit = async () => {
        pdfUrl && fileName && await downloadFileFromUrl(pdfUrl, fileName)
    }

    return (
        <Modal
            modalId={ModalId.DOWNLOAD_INVOICE}
            title='Descargar Documento Fiscal'
            submitLabel="Descargar"
            submitIcon="download"
            onSubmit={onSubmit}
        >
            <FileTile
                fileType={FileType.PDF}
                fileName={fileName}
            />
        </Modal>
    )
}
